import { render, staticRenderFns } from "./TicketDistributionsByStatus.vue?vue&type=template&id=85e27fdc&scoped=true"
import script from "./TicketDistributionsByStatus.vue?vue&type=script&lang=js"
export * from "./TicketDistributionsByStatus.vue?vue&type=script&lang=js"
import style0 from "./TicketDistributionsByStatus.vue?vue&type=style&index=0&id=85e27fdc&prod&lang=scss"
import style1 from "./TicketDistributionsByStatus.vue?vue&type=style&index=1&id=85e27fdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e27fdc",
  null
  
)

export default component.exports